import axios from 'axios';
const CONTENT_TYPE = 'application/json';

const country = localStorage.getItem('country');

export const revenueClient = axios.create({
  baseURL:
    country === 'CO'
      ? process.env.REACT_APP_REVENUE_API_URL_CO
      : process.env.REACT_APP_REVENUE_API_URL,
  headers: {
    'x-api-key':
      country === 'CO'
        ? process.env.REACT_APP_REVENUE_API_KEY_CO ?? ''
        : process.env.REACT_APP_REVENUE_API_KEY ?? '',
    'Content-Type': CONTENT_TYPE,
  },
});
